/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Buttons from "views/Components/Buttons.jsx";
import Calendar from "views/Calendar/Calendar.jsx";
import Charts from "views/Charts/Charts.jsx";
import CounselorManager from "views/Members/CounselorManager.jsx";
import CouponManager from "views/Coupon/CouponManager.jsx";
import DashboardForSuperAdmin from "views/Dashboard/DashboardForSuperAdmin.jsx";
import DashboardForAssociation from "views/Dashboard/DashboardForAssociation.jsx";
import DashboardForOrg from "views/Dashboard/DashboardForOrg.jsx";
import DashboardForPerson from "views/Dashboard/DashboardForPerson.jsx";
import DocManager from 'views/Docs/DocManager.jsx';
import EnbrainIntroPage from "views/Pages/EnbrainIntroPage.jsx";
import ErrorPage from "views/Pages/ErrorPage.jsx";
import ExtendedForms from "views/Forms/ExtendedForms.jsx";
import ExtendedTables from "views/Tables/ExtendedTables.jsx";
import FormManager from 'views/Forms/FormManager.jsx';
import FullScreenMap from "views/Maps/FullScreenMap.jsx";
import GoogleMaps from "views/Maps/GoogleMaps.jsx";
import GradedPersonProfile from "views/Members/GradedPersonProfile";
import Form02_04 from "views/Forms/CustomForms/Form02_04.jsx";
import Form04 from "views/Forms/CustomForms/Form04.jsx";
import GridSystem from "views/Components/GridSystem.jsx";
import Icons from "views/Components/Icons.jsx";
import LockScreenPage from "views/Pages/LockScreenPage.jsx";
import LoginPage from "views/Pages/LoginPage.jsx";
import MemberManager from 'views/Members/MemberManager.jsx';
import MessageGroups from "views/Messages/MessageGroups.jsx";
import Migration from "views/Migration/Migration.jsx";
import Notifications from "views/Components/Notifications.jsx";
import Panels from "views/Components/Panels.jsx";
import PricingPage from "views/Pages/PricingPage.jsx";
import ReactTables from "views/Tables/ReactTables.jsx";
import RegisterPage from "views/Pages/RegisterPage.jsx";
import RegisterOrgPage from "views/Pages/RegisterOrgPage.jsx";
import RegularForms from "views/Forms/RegularForms.jsx";
import RegularTables from "views/Tables/RegularTables.jsx";
// import RoleManager from 'views/Roles/RoleManager.jsx';
import SweetAlert from "views/Components/SweetAlert.jsx";
import TimelinePage from "views/Pages/Timeline.jsx";
import Typography from "views/Components/Typography.jsx";
import UserProfile from "views/Pages/UserProfile.jsx";
import UserManager from "views/Users/UserManager";
import OrgManager from "views/Orgs/OrgManager";
import ValidationForms from "views/Forms/ValidationForms.jsx";
import VectorMap from "views/Maps/VectorMap.jsx";
import Widgets from "views/Widgets/Widgets.jsx";
import Wizard from "views/Forms/Wizard101.jsx";

import Terms from "views/Terms/toc.jsx";
import Privacy from "views/Terms/privacy.jsx";
import ThirdParty from "views/Terms/thirdparty.jsx";

// @material-ui/icons
import Apps from "@material-ui/icons/Apps";
import AllInbox from '@material-ui/icons/AllInbox';
import Business from '@material-ui/icons/Business';
import DashboardIcon from "@material-ui/icons/Dashboard";
import DateRange from "@material-ui/icons/DateRange";
import GridOn from "@material-ui/icons/GridOn";
import Image from "@material-ui/icons/Image";
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import Loyalty from '@material-ui/icons/Loyalty';
import Place from "@material-ui/icons/Place";
import People from '@material-ui/icons/People';
import Timeline from "@material-ui/icons/Timeline";
import WidgetsIcon from "@material-ui/icons/Widgets";

import { ROLES } from "constants/user";
import HomepageScreen from "views/Homepage/HomepageScreen";
import Messages from "views/Messages/Messages";

const redirect = true; // production
// const redirect = false; // development
var dashRoutes = [
  {
    path: "/dashboardForSuperAdmin",
    name: "통계데이터(최고관리자)",
    icon: DashboardIcon,
    component: DashboardForSuperAdmin,
    layout: "/admin",
    roles: [ROLES.SUPER_ADMIN]
  },
  {
    redirect,
    path: "/migration",
    name: "데이터이관",
    icon: DashboardIcon,
    component: Migration,
    layout: "/admin",
    roles: [ROLES.SUPER_ADMIN]
  },
  {
    path: "/dashboardForAssociation",
    name: "통계데이터(협회)",
    icon: DashboardIcon,
    component: DashboardForAssociation,
    layout: "/admin",
    roles: [ROLES.ASSOCIATION_ADMIN]
  },
  {
    redirect,
    path: "/dashboardForOrg",
    name: "통계데이터(기관)",
    icon: DashboardIcon,
    component: DashboardForOrg,
    layout: "/admin",
    roles: [ROLES.SUPER_ADMIN]
  },
  {
    path: "/dashboardForOrg",
    name: "통계데이터(기관)",
    icon: DashboardIcon,
    component: DashboardForOrg,
    state: ['org_id'],
    layout: "/admin",
    roles: [ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR]
  },
  {
    redirect,
    path: "/dashboardForPerson",
    name: "통계데이터(일반회원)",
    icon: DashboardIcon,
    component: DashboardForPerson,
    layout: "/admin",
    roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR]
  },
  {
    path: "/dashboardForPerson",
    name: "통계데이터(일반회원)",
    icon: DashboardIcon,
    component: DashboardForPerson,
    layout: "/admin",
    roles: [ROLES.PERSONAL_USER]
  },
  // {
  //   path: '/roles',
  //   name: "권한관리",
  //   icon: Person,
  //   component: RoleManager,
  //   layout: "/admin",
  //   roles: [ROLES.SUPER_ADMIN]
  // },
  {
    path: '/orgs',
    name: '기관리스트',
    icon: Business,
    component: OrgManager,
    layout: '/admin',
    roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN]
  },
  {
    path: '/users',
    name: '사용자 관리',
    icon: People,
    component: UserManager,
    layout: '/admin',
    roles: [ROLES.SUPER_ADMIN]
  },
  {
    path: '/counselors',
    name: '상담사 관리',
    icon: People,
    component: CounselorManager,
    layout: '/admin',
    roles: [ROLES.SUPER_ADMIN, ROLES.ORG_ADMIN]
  },
  {
    path: '/members',
    name: '대상자 프로파일',
    icon: People,
    component: MemberManager,
    layout: '/admin',
    roles: [ROLES.SUPER_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR]
  },
  {
    path: '/forms',
    name: '사례관리서식지',
    icon: LibraryBooks,
    component: FormManager,
    layout: '/admin',
    roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR]
  },
  {
    path: '/docs',
    name: '기관사례 관리',
    icon: AllInbox,
    component: DocManager,
    layout: '/admin',
    roles: [ROLES.SUPER_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR]
  },
  {
    redirect,
    path: '/messages',
    name: '한 줄 의견 남기기',
    icon: AllInbox,
    component: Messages,
    layout: '/admin',
    roles: [ROLES.SUPER_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR]
  },
  {
    path: '/coupons',
    name: '쿠폰발급관리',
    icon: Loyalty,
    component: CouponManager,
    layout: '/admin',
    roles: [ROLES.SUPER_ADMIN]
  },
  {
    redirect,
    collapse: true,
    name: "Pages",
    rtlName: "صفحات",
    icon: Image,
    state: "pageCollapse",
    views: [
      {
        path: "/pricing-page",
        name: "이용료 안내",
        rtlName: "عالتسعير",
        mini: "PP",
        rtlMini: "ع",
        component: PricingPage,
        layout: "/auth"
      },
      {
        path: "/timeline-page",
        name: "타임라인",
        rtlName: "تيالجدول الزمني",
        mini: "T",
        rtlMini: "تي",
        component: TimelinePage,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
      },
      {
        path: "/login-page",
        name: "로그인",
        rtlName: "هعذاتسجيل الدخول",
        mini: "L",
        rtlMini: "هعذا",
        component: LoginPage,
        layout: "/auth"
      },
      {
        path: "/register-page",
        name: "기관가입",
        rtlName: "تسجيل",
        mini: "R",
        rtlMini: "صع",
        component: RegisterOrgPage,
        layout: "/auth"
      },
      {
        path: "/about-enbrain",
        name: "엔브레인플랫폼 소개",
        rtlName: "اقفل الشاشة",
        mini: "LS",
        rtlMini: "هذاع",
        component: EnbrainIntroPage,
        layout: "/auth"
      },
      {
        path: "/lock-screen-page",
        name: "잠금화면",
        rtlName: "اقفل الشاشة",
        mini: "LS",
        rtlMini: "هذاع",
        component: LockScreenPage,
        layout: "/auth"
      },
      {
        path: "/user-page",
        name: "유저 프로필",
        rtlName: "ملف تعريفي للمستخدم",
        mini: "UP",
        rtlMini: "شع",
        component: UserProfile,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]

      },
      {
        path: "/error-page",
        name: "에러 페이지",
        rtlName: "صفحة الخطأ",
        mini: "E",
        rtlMini: "البريد",
        component: ErrorPage,
        layout: "/auth"
      },
      {
        path: "/terms",
        name: "이용약관",
        component: Terms,
        layout: "/auth"
      },
      {
        path: "/privacy",
        name: "개인정보 보호 정책",
        component: Privacy,
        layout: "/auth"
      },
      {
        path: "/third-party-privacy",
        name: "개인정보 제3자 제공동의",
        component: ThirdParty,
        layout: "/auth"
      }
    ]
  },
  {
    redirect,
    collapse: true,
    name: "Components",
    rtlName: "المكونات",
    icon: Apps,
    state: "componentsCollapse",
    views: [
      {
        collapse: true,
        name: "Multi Level Collapse",
        rtlName: "انهيار متعدد المستويات",
        mini: "MC",
        rtlMini: "ر",
        state: "multiCollapse",
        views: [
          {
            path: "/buttons",
            name: "Buttons",
            rtlName: "وصفت",
            mini: "B",
            rtlMini: "ب",
            component: Buttons,
            layout: "/admin",
            roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]

          }
        ]
      },
      {
        path: "/buttons",
        name: "Buttons",
        rtlName: "وصفت",
        mini: "B",
        rtlMini: "ب",
        component: Buttons,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]

      },
      {
        path: "/grid-system",
        name: "Grid System",
        rtlName: "نظام الشبكة",
        mini: "GS",
        rtlMini: "زو",
        component: GridSystem,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]

      },
      {
        path: "/panels",
        name: "Panels",
        rtlName: "لوحات",
        mini: "P",
        rtlMini: "ع",
        component: Panels,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]

      },
      {
        path: "/sweet-alert",
        name: "Sweet Alert",
        rtlName: "الحلو تنبيه",
        mini: "SA",
        rtlMini: "ومن",
        component: SweetAlert,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]

      },
      {
        path: "/notifications",
        name: "Notifications",
        rtlName: "إخطارات",
        mini: "N",
        rtlMini: "ن",
        component: Notifications,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
      },
      {
        path: "/icons",
        name: "Icons",
        rtlName: "الرموز",
        mini: "I",
        rtlMini: "و",
        component: Icons,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
      },
      {
        path: "/typography",
        name: "Typography",
        rtlName: "طباعة",
        mini: "T",
        rtlMini: "ر",
        component: Typography,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
      }
    ]
  },
  {
    redirect,
    collapse: true,
    name: "Forms",
    rtlName: "إستمارات",
    icon: "content_paste",
    state: "formsCollapse",
    views: [
      {
        path: "/regular-forms",
        name: "Regular Forms",
        rtlName: "أشكال عادية",
        mini: "RF",
        rtlMini: "صو",
        component: RegularForms,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
      },
      {
        path: "/extended-forms",
        name: "Extended Forms",
        rtlName: "نماذج موسعة",
        mini: "EF",
        rtlMini: "هوو",
        component: ExtendedForms,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
      },
      {
        path: "/validation-forms",
        name: "Validation Forms",
        rtlName: "نماذج التحقق من الصحة",
        mini: "VF",
        rtlMini: "تو",
        component: ValidationForms,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
      },
      {
        path: "/wizard",
        name: "",
        rtlName: "ساحر",
        mini: "W",
        rtlMini: "ث",
        component: Wizard,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
      }
    ]
  },
  {
    redirect,
    collapse: true,
    name: "Tables",
    rtlName: "الجداول",
    icon: GridOn,
    state: "tablesCollapse",
    views: [
      {
        path: "/regular-tables",
        name: "Regular Tables",
        rtlName: "طاولات عادية",
        mini: "RT",
        rtlMini: "صر",
        component: RegularTables,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
      },
      {
        path: "/extended-tables",
        name: "Extended Tables",
        rtlName: "جداول ممتدة",
        mini: "ET",
        rtlMini: "هور",
        component: ExtendedTables,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
      },
      {
        path: "/react-tables",
        name: "React Tables",
        rtlName: "رد فعل الطاولة",
        mini: "RT",
        rtlMini: "در",
        component: ReactTables,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
      }
    ]
  },
  {
    redirect,
    collapse: true,
    name: "Maps",
    rtlName: "خرائط",
    icon: Place,
    state: "mapsCollapse",
    views: [
      {
        path: "/google-maps",
        name: "Google Maps",
        rtlName: "خرائط جوجل",
        mini: "GM",
        rtlMini: "زم",
        component: GoogleMaps,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
      },
      {
        path: "/full-screen-maps",
        name: "Full Screen Map",
        rtlName: "خريطة كاملة الشاشة",
        mini: "FSM",
        rtlMini: "ووم",
        component: FullScreenMap,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
      },
      {
        path: "/vector-maps",
        name: "Vector Map",
        rtlName: "خريطة المتجه",
        mini: "VM",
        rtlMini: "تم",
        component: VectorMap,
        layout: "/admin",
        roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
      }
    ]
  },
  {
    redirect,
    path: "/widgets",
    name: "Widgets",
    rtlName: "الحاجيات",
    icon: WidgetsIcon,
    component: Widgets,
    layout: "/admin",
    roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
  },
  {
    redirect,
    path: "/charts",
    name: "Charts",
    rtlName: "الرسوم البيانية",
    icon: Timeline,
    component: Charts,
    layout: "/admin",
    roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
  },
  {
    redirect,
    path: "/calendar",
    name: "Calendar",
    rtlName: "التقويم",
    icon: DateRange,
    component: Calendar,
    layout: "/admin",
    roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
  },
  {
    redirect: true,
    path: "/gradedPersonProfile",
    name: "인지지원등급자 프로파일",
    component: GradedPersonProfile,
    layout: "/admin",
    roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR]
  },
  {
    redirect: true,
    path: "/customForms/form04",
    name: "등급자 프로파일 (서식4)",
    component: Form04,
    layout: "/admin",
    roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
  },
  {
    redirect: true,
    path: "/customForms/form02_04",
    name: "인지기능 영역별 기록지 (서식2-4)",
    component: Form02_04,
    layout: "/admin",
    roles: [ROLES.SUPER_ADMIN, ROLES.ASSOCIATION_ADMIN, ROLES.ORG_ADMIN, ROLES.ORG_COUNSELOR, ROLES.PERSONAL_USER]
  },

];
export default dashRoutes;
